import i18n from "i18next";
import { initReactI18next } from "react-i18next";

// the translations
// (tip move them in a JSON file and import them)
const resources = {
    en: {
        translation: {
            // Navbar
            "announcement":"Pre-sale offer! August 2020 launch prices online now!",
            "start":"Start",
            "activity-nav":"activities",
            "price":"Price",
            "companions":"Companions",
            "The company":"The company",
            "slang": "you have been looking for!",
            "slang-des": "Company and non-medical care for the elderly.",
            "activities": "Daytime activities",
            "activity-des": "Our colleagues spend quality time with our clients. We offer visits when you need it!",
            "activity-des2": "In all our plans there is plenty of time for various activities!",
            "schedule": "Schedule",
            "book-visit": "Book your visits whenever you want!",
            "date-time": "Monday to Friday from 9:00 a.m. to 9:00 p.m.",
            // cards
            "price-plan": "Price plan",
            "3 plans":"3 plans",
            "visit":"visit",
        
            "price-des": "We currently offer 3 plans to choose from and a trial visit.",
            "Launch": "AUGUST 2020 LAUNCH PRICES:",
            "one-time":"One-time Payment",
            "single-visit":"single visit",
            "minutes":"minutes",
            "pre-sale":"Pre-sale only",
            "bill-monthly":"Billed Monthly",
            "visit-week":"visit per week",
            "visits-week":"visits per week",
            "total-visits":"total visits",
            "visits":"visits",
            "minutes-per":"minutes / per visit",
            "no-cridit":"No Credit Card Required",
            "get":"GET",
            "trial":"TRIAL",
            "bronze":"BRONZE",
            "silver":"SILVER",
            "gold":"GOLD",
            
            "price-activity": "All plans include all available activities.",
            "contact-email": "If you need more company hours send us an email to:info@companio.care",
            "our-companions": "Our companions",
            "companions-des": "Our colleagues are normal people . They are your neighbors, mothers and fathers, students and professionals looking for a change.",
            "filter-companions": "Before becoming a partner, each of the people are subjected to a rigorous selection process which includes:",
            "qoute0.1": "My Mother loves companion Caria, She takes her out for walks and has coffee with her.",
            "qoute0.2": "It wasn't easy to get my mother to agree to a companion, but it worth it!",
            "client":"Client",
            "about-us":"ABOUT US",
            "about-des":"Companio Care a HealthTech startup changing the way we care for elderly",
            "rights":"@ 2020 Companio Care All rights reserved",
            "location":"LOCATION",
            "barcelona":"Barcelona, Spain",
            "get-in-touch":"GET IN TOUCH",
            "get-in-touch-des":"if you need to get in touch with us, please leave your email below."
        }
    },
    sp: {
        translation: {
           // Navbar
           "announcement":"Oferta de preventa! Agosto 2020 pre precios de lanzamiento online ahora!",
           "start":"Inicio",
           "activity-nav":"Actividades",
           "price":"Precios",
           "companions":"Compañeros",
           "The company":"La compañía",
           "slang": "que has estado buscando",
           "slang-des": "Compañía y cuidado no médico para personas mayoers.",
           "activities": "Actividades diurnas",
           "activity-des": "Nuestros compañeros pasan tiempo de calidad con nuestros clientes Ofrecemos visitas cuando lo necesites!",
           "activity-des2": "En todos nuestros planes hay mucho tiempo para actividades diversas!",
           "schedule": "Horarios",
           "book-visit": "Reserva tus visitas cuando quieras!",
           "date-time": "Lunes a Vienes desde las 9:00 hasta las 21:00",
           // cards
           "price-plan": "Plan de precios",
           "price-des": "Actualmente ofrecemos 3 planes para escoger y una visita de pruebe.",
           "Launch": "AGOSTO 2020 PRECIOS DE LANZAMIENTO:",
           "one-time":"único Pago",
           "single-visit":"visita simple",
           "minutes":"minutos",
           "pre-sale":"Preventa",
           "bill-monthly":"Pago Mensual",
           "visit-week":"visita por semana",
           "total-visits":"visitas en total",
           "visits":"visits",
           "minutes-per":"minutos / por visita",
           "no-cridit":"No se requiere tarjeta de crédito",
           "get":"COMPRAR",
           "trial":"PRUEBA",
           "bronze":"BRONCE",
           "silver":"PLATA",
           "gold":"ORO",
           
           "price-activity": "Todos los planes incluyen todas las actividades disponibles",
           "contact-email": "Si necesito más horas de compaños un correo a",
           "our-companions": "Nuestros compañeros",
           "companions-des": "Nuestros compañeros son personas normales. Ellos son tus vecinos, madres y padres, estudiantes y profesionales buscando un cambio",
           "filter-companions": "Antes de convertirse en un compañero, cada una de las personas son sometidas a un riguroso proceso de selección que incluye lo siguiente",
           "qoute0.1": "Mi madre ama a su compañera Caria, la lleva a  dar paseos y toman café juntas.",
           "qoute0.2": "No fue fácil convencer a mi madre de accptar a  a un acompanante pero al final valió la pena.",
           "client":"Cliente",
           "about-us":"ACERCA DE NOSOTROS",
           "about-des":"Companoio Care es un HeaithTech start-up combiando la manera en que cuidamos a las personas mayores!",
           "rights":"@ 2020 Companio Care. Todos los derechos reservados",
           "location":"UBICACION",
           "barcelona":"Barcelona, España",
           "get-in-touch":"CONTACTO",
           "get-in-touch-des":"Si tienes alguna duda, déjanos tu correo y nos pondremos en contacto dontigo"
        }
    }
};

i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: "en",

        keySeparator: false, // we do not use keys in form messages.welcome

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;